import React from "react";
import { KeyValueList, Section, ValueOrPlaceholder } from "@sscs/ui";
import { ML_APPROACH_TO_TEXT } from "../../../utils";
const ModelCardSection = ({ modelCard, title, }) => (React.createElement(Section, null,
    React.createElement(Section.Title, { as: "h3" }, title),
    React.createElement(Section.Content, null,
        React.createElement(KeyValueList, { list: {
                Publisher: React.createElement(ValueOrPlaceholder, { value: modelCard.publisher }),
                Product: React.createElement(ValueOrPlaceholder, { value: modelCard.product }),
                Version: React.createElement(ValueOrPlaceholder, { value: modelCard.version }),
                License: React.createElement(ValueOrPlaceholder, { value: modelCard.license }),
                "Learning type": ML_APPROACH_TO_TEXT[modelCard.approach],
                "Model architecture": (React.createElement(ValueOrPlaceholder, { value: modelCard.type, placeholder: "Unknown architecture" })),
                "Architecture family": (React.createElement(ValueOrPlaceholder, { value: modelCard.family })),
                Task: React.createElement(ValueOrPlaceholder, { value: modelCard.task }),
                Inputs: React.createElement(ValueOrPlaceholder, { value: modelCard.inputs.join(", ") }),
                Outputs: React.createElement(ValueOrPlaceholder, { value: modelCard.outputs.join(", ") }),
                ...Object.fromEntries(modelCard.properties),
            } }))));
export default ModelCardSection;
//# sourceMappingURL=ModelCardSection.js.map